type PaygFormat = `PAYG ${string} ${string} ${string}`;
type ProFormat = `Pro ${string}`;
type ApiFormat = 'API';
export type PlanCode = ApiFormat | PaygFormat | ProFormat;

export enum OnboardingLocalStorageKeys {
  ONBOARDING_BUSINESS_TYPE = 'shippo_onboarding_business_type',
  ONBOARDING_IN_PROGRESS = 'onboarding_in_progress',
  SHOULD_ONBOARD = 'shippo_should_onboard',
}
